import type { LeavePolicyInput } from '../types/SettingModuleTypes'

export const GeneralSettingInitialInput = {
  fiscal_year_start_date: '',
  fiscal_year_end_date: '',
  weekends: [],
  week_start_day: '',
  inTime: '',
  outTime: '',
}

export const LeaveConfigInitialInput = {
  sandwichEnabled: '',
  deductOnApproval: '',
  lopCalculationType: '',
  restrictDateRange: '',
  allowBackdatedLeave: '',
  balanceCreditType: '',
}

export const LeavePolicyInitialInput: LeavePolicyInput = {
  leaveTypeId: '',
  totalPerYear: '',
  maxDaysPerRequest: '',
  minAdvanceNotice: '',
  allowBackdated: '',
  allowEmergency: '',
  autoApprove: '',
  requiresApproval: '',
  isPaid: '',
  isProRated: '',
  proRataType: '',
  proRataApplicableLeaves: '',
  proRataCalculationRules: '',
  allowCarry: '',
  carryLimit: '',
}

export const LeaveTypeInitialInput = {
  name: '',
  description: '',
}
